import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.less']
})
export class BaseModalComponent implements OnInit {
  @Input() data;
  @Input() allUsers;
  public title: string;
  public show;

  constructor(private ngbActiveMod: NgbActiveModal) {

  }

  ngOnInit() {
    this.init();
  }

  private init() {
    this.show = this.data.from;
    switch (this.show) {
      case 'users':
        this.title = 'Users';
        break;
      case 'admins':
        this.title = 'Admins';
        break;

      case 'transactions':
        this.title = 'Transactions';
        break;

      case 'vouchers':
        this.title = 'Vouchers';
        break;

      case 'redeem':
        this.title = 'Redeems';
        break;
        
      case 'license':
        this.title = 'License'
        break;

      case 'managers':
        this.title = "Managers"
        break;
    }
  }

  // closes the modal
  public closeModal() {
    this.ngbActiveMod.close({ task: 'close modal', success: true });
  }
}
